import { ReactElement } from 'react';

import { visitPaths } from '~libs.desktop.shared.paths';

import { ChipFilter } from '../ChipFilter';
import { useAppointmentsFiltersContext } from '../../AppointmentFilter.context';
import { patientPresenceFilterStorage } from '../../AppointmentsFilterPanel/fields/PatientPresenceField/PatientPresenceField.storage';

import { usePatientPresenceFilterLabel } from './PatientPresenceChipFilter.hooks';

export const PatientPresenceChipFilter = (): ReactElement | null => {
   const { getFilter } = useAppointmentsFiltersContext();

   const patientPresences = getFilter('patientPresence');
   const label = usePatientPresenceFilterLabel(patientPresences);

   if (!patientPresences.length) {
      return null;
   }
   return (
      <ChipFilter
         label={label}
         searchParamKey={visitPaths.PATIENT_PRESENCE_SEARCH_PARAM}
         testId={'patientPresence'}
         onClick={patientPresenceFilterStorage.deleteFilter}
      />
   );
};
